<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="contacts"
      class="elevation-1"
      :loading="isLoading"
      dense
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-btn
            color="success"
            data-cy="Contact-button-new"
            @click="$router.push({
              name: 'contracts-EditContact'
            })"
          >
            <v-icon class="mr-2">
              {{ mdiPlus }}
            </v-icon>
            {{ $t('common.buttons.new') }}
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.name="{ item }">
        <router-link :to="{ name: 'contracts-EditContact', query: { id: item.contactID } }">
          {{ item.name }}
        </router-link>
      </template>
      <template v-slot:item.actions="{ item }">
        <TableBasicButtons :editLink="{
            name: 'contracts-EditContact',
            query: {id: item.contactID}
          }"
          @delete="remove(item)"
        />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListContact',
  module: 'Contact',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  meta: {
    breadcrumb:
      [{
        text: 'menu.home',
        to: { name: 'app-Home' },
        disabled: false,
      },
      {
        text: 'menu.contacts',
        disabled: true,
      },
      ],
  },
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('contacts', ['contacts']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('name'),
          value: 'name',
        },
        {
          text: this.$$t('emailAddress'),
          value: 'emailAddress',
        },
        {
          text: this.$$t('phone'),
          value: 'phone',
        },
        {
          text: this.$$t('address'),
          value: 'address',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('contacts', ['LOAD_contacts', 'DELETE_contact']),
    /** Delete Contact from the collection
     */
    async remove(contact) {
      this.isLoading = true;
      await this.DELETE_contact(contact.contactID);
      await this.LOAD_contacts();
      this.isLoading = false;
    },
    async refresh() {
      this.isLoading = true;
      await this.LOAD_contacts();
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# Contact example

'''js
<Contact />
'''
</docs>
